import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllSuppliers } from "../../api/apiSuppliers";
import toast from "react-hot-toast";

const useRestoreAllSuppliers = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAllSuppliersMutate, isPending } = useMutation({
        mutationFn: restoreAllSuppliers,
        onSuccess: (res) => {
            toast.success(res.message || "All suppliers restored successfully");
            queryClient.invalidateQueries({ queryKey: ["suppliers"] });
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to restore suppliers");
        },
    });

    return { restoreAllSuppliersMutate, isPending };
};

export default useRestoreAllSuppliers;
